import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import * as holidayApi from "../../../api/holiday";

export function useHolidays() {
  return useQuery({
    queryKey: ["holidays"],
    queryFn: () => holidayApi.fetchAll(),
  });
}

export function useSaveHoliday() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (req) => holidayApi.save(null, req),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["holidays"] }),
  });
}
